fccd-image {
  @media screen and (max-width: 767px) {
    .img-show-xs {
      display: block;
    }
    .img-hide-xs {
      display: none;
    }
  }

  @media screen and (min-width: 768px) and (max-width: 991px) {
    .img-show-sm {
      display: block;
    }
    .img-hide-sm {
      display: none;
    }
  }

  @media screen and (min-width: 992px) and (max-width: 1199px) {
    .img-show-md {
      display: block;
    }
    .img-hide-md {
      display: none;
    }
  }

  @media screen and (min-width: 1199px) {
    .img-show-lg {
      display: block;
    }
    .img-hide-lg {
      display: none;
    }
  }
}
